(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[class*="gr-card-text-"]').forEach(function (p) {
    var full = p.getAttribute('data-full') || p.textContent.trim();
    var limit = parseInt(p.getAttribute('data-truncate'), 10) || 120;
    if (full.length <= limit) return;

    var sectionEl = p.closest('[id^="shopify-section-"]');
    var sid = sectionEl ? sectionEl.id.replace('shopify-section-', '') : '';

    var short = full.slice(0, limit).trimEnd() + '…';
    p.textContent = short;

    var btn = document.createElement('button');
    btn.className = 'gr-show-more-' + sid;
    btn.textContent = 'Show More';
    var expanded = false;

    btn.addEventListener('click', function () {
      expanded = !expanded;
      p.textContent = expanded ? full : short;
      btn.textContent = expanded ? 'Show Less' : 'Show More';
      p.parentNode.insertBefore(btn, p.nextSibling);
    });

    p.parentNode.insertBefore(btn, p.nextSibling);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
